import AlertBanner from 'Feature/Alerts/AlertBanner';
import PageFooter from 'Feature/Chrome/Footer/PageFooter';
import { PageHeader } from 'Feature/Chrome/PageHeader';
import Slider from 'Feature/Slider/Slider';
import './StandardPage.scss';
import { Outlet } from 'react-router';
import { useEffect, useState } from 'react';
import Confetti from 'Feature/Confetti/Confetti';
import { createPortal } from 'react-dom';
import { useUserData } from 'Foundation/User/UserContext';

export default function StandardPage() {
  const {userData} = useUserData();
  const [showConfetti, setShowConfetti] = useState<boolean>(false);

  const runConfetti = () => {
    if (window.location.search && window.location.search.indexOf('confetti') != -1) setShowConfetti(true);
  };

  useEffect(() => {
    runConfetti();
  }, []);

  return (
    <>
      {showConfetti && <Confetti />}
      {createPortal(<PageHeader></PageHeader>, document.getElementsByTagName('header')[0])}
      {userData && createPortal(<Slider></Slider>, document.getElementsByTagName('main')[0])}
      {createPortal(
        <>
          <Outlet />
          <AlertBanner></AlertBanner>
        </>,
        document.getElementById('content') as Element,
      )}
      {createPortal(<PageFooter></PageFooter>, document.getElementsByTagName('footer')[0])}
    </>
  );
}
